import React from "react";

/**
 * BATIK Tour & Travel logo — clean pre-processed transparent PNG.
 */

export const LOGO_HORIZONTAL = "/logo-horizontal.png";

export function TransparentImage({ src, alt = "", className = "", style = {}, variant = "auto" }) {
  const isLight = variant === "light";
  return (
    <img
      src={src}
      alt={alt}
      className={`${className} object-contain select-none`}
      loading="lazy"
      draggable={false}
      style={{ ...style, ...(isLight ? { filter: "invert(1) hue-rotate(180deg)" } : {}) }}
    />
  );
}

export default function BrandLogo({
  layout = "horizontal",
  variant = "auto",
  className = "h-12 w-auto",
}) {
  return <TransparentImage src={LOGO_HORIZONTAL} alt="BATIK Tour & Travel — PT Baitullah Tiga Kharisma" className={className} variant={variant} />;
}
